import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const navLinks = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.services'), href: '/services' },
    { label: t('nav.about'), href: '/about' },
    { label: t('nav.contact'), href: '/contact' },
  ];

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-primary-600/95 backdrop-blur-md border-b border-primary-700/30">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/15 text-background-50">
              <i className="ri-shining-line text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-background-50">
              Limpia
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'text-background-50 font-semibold'
                    : 'text-background-50/85 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <LanguageSwitcher light />
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 text-primary-700 text-sm font-semibold transition-all hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              {t('nav.quote')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="md:hidden flex items-center gap-2">
            <LanguageSwitcher light />
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer text-background-50"
              aria-label="Toggle menu"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium px-4 py-2.5 rounded-lg transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 py-2">
              <LanguageSwitcher />
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold transition-all hover:bg-primary-600 whitespace-nowrap cursor-pointer mt-2"
            >
              {t('nav.quote')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}